import React from 'react'
import './index.less'

export default function Form(props) {
  const { currentTags } = props
  return (
    <div className='form-wrapper'>
      {currentTags.map((item) => {
        return (
          <div className='form-tags' key={item}>
            {item}
          </div>
        )
      })}
    </div>
  )
}
